import StripesProvider from './stripes-provider/stripes-provider';
import StripesRegular from './stripes-regular/stripes-regular';

export { StripesRegular, StripesProvider };